import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'user-terms-message',
  templateUrl: './user-terms.component.html',
  styleUrls: ['./user-terms.component.less']
})
export class UserTermsMessage implements OnInit {


  constructor(
 
  ) {}
  
  ngOnInit(): void {
  }
  


}
